import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../.';
import { EmailRequest } from './communication';

export const communicationApi = createApi({
  reducerPath: 'communicationApi',
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    sendEmail: builder.mutation<void, EmailRequest>({
      query: request => ({
        url: `communication/email`,
        method: 'POST',
        data: request,
      }),
    }),
  }),
});

export const { useSendEmailMutation } = communicationApi;
